import { render, staticRenderFns } from "./comment-one.vue?vue&type=template&id=6d38964e&scoped=true&"
import script from "./comment-one.vue?vue&type=script&lang=js&"
export * from "./comment-one.vue?vue&type=script&lang=js&"
import style0 from "./comment-one.vue?vue&type=style&index=0&id=6d38964e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d38964e",
  null
  
)

export default component.exports